import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getOfferAddonRoute } from "@api-routes/eirSalesFacade";
import { mapEirSalesOfferAddonList } from "@modules/eirSalesFacade/mappers/mapEirSalesOfferAddonList";
import { IEirSalesOfferAddon } from "@modules/eirSalesFacade/interfaces/models/IEirSalesOfferAddon";

export const getEirSalesOfferAddons = (prospectReference: string, offerId: number, options: IFetchOptions = {}) =>
    fetcher<IEirSalesOfferAddon[]>(getOfferAddonRoute(prospectReference, offerId), {
        ...options,
        mapper: mapEirSalesOfferAddonList,
    });
